(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["twmp-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.twmp-faq-root__trigger');
  if (!trigger) return;
  var item = trigger.closest('.twmp-faq-root__item');
  if (!item) return;
  item.classList.toggle('is-open');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twmp-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.twmpProductsBound === '1') return;
    root.dataset.twmpProductsBound = '1';

    var cards = root.querySelectorAll('.twmp-products-root__card');
    cards.forEach(function (card) {
      var toggle = card.querySelector('.twmp-products-root__card-sub-toggle');
      if (!toggle) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOn = card.classList.contains('is-sub');
        var onePrice = card.getAttribute('data-one-price') || '';
        var subPrice = card.getAttribute('data-sub-price') || '';
        var salePrice = card.getAttribute('data-sale-price') || '';
        var subBtnLabel = card.getAttribute('data-sub-btn-label') || 'Subscribe';
        var oneBtnLabel = card.getAttribute('data-one-time-btn-label') || 'Add to Cart';
        var priceMain = card.querySelector('.price-main');
        var priceSuffix = card.querySelector('.price-suffix');
        var priceCompare = card.querySelector('.price-compare');
        var actionBtn = card.querySelector('.action-btn');
        var knob = card.querySelector('.twmp-products-root__sub-knob');
        var spInput = card.querySelector('[data-sp-input]');

        if (isOn) {
          card.classList.remove('is-sub');
          card.classList.add('is-one');
          toggle.style.backgroundColor = '#D1D5DB';
          if (knob) knob.style.transform = 'translateX(0px)';
          if (priceMain) priceMain.textContent = onePrice;
          if (priceSuffix) priceSuffix.textContent = '';
          if (priceCompare) priceCompare.textContent = salePrice;
          if (actionBtn) {
            actionBtn.textContent = oneBtnLabel;
            actionBtn.classList.remove('action-btn--sub');
            actionBtn.classList.add('action-btn--one');
          }
          if (spInput) spInput.removeAttribute('name');
        } else {
          card.classList.remove('is-one');
          card.classList.add('is-sub');
          toggle.style.backgroundColor = '#03793e';
          if (knob) knob.style.transform = 'translateX(18px)';
          if (priceMain) priceMain.textContent = subPrice;
          if (priceSuffix) priceSuffix.textContent = '/4wks';
          if (priceCompare) priceCompare.textContent = onePrice;
          if (actionBtn) {
            actionBtn.textContent = subBtnLabel;
            actionBtn.classList.remove('action-btn--one');
            actionBtn.classList.add('action-btn--sub');
          }
          if (spInput) spInput.setAttribute('name', 'selling_plan');
        }
      });
    });

    var scroller = root.querySelector('.twmp-products-root__scroll');
    if (scroller) {
      var checkOverflow = function () {
        if (scroller.scrollWidth > scroller.clientWidth + 4) {
          scroller.classList.add('is-overflowing');
        } else {
          scroller.classList.remove('is-overflowing');
        }
      };
      checkOverflow();
      window.addEventListener('resize', checkOverflow);

      var prev = root.querySelector('.twmp-products-root__arrow--prev');
      var next = root.querySelector('.twmp-products-root__arrow--next');
      if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -320, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { scroller.scrollBy({ left:  320, behavior: 'smooth' }); });
    }
  }

  function boot() {
    document.querySelectorAll('.twmp-products-root').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.twmp-products-root');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twmp-reviews-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function fmt(v, dec, comma){
    var s = v.toFixed(dec);
    if(comma){
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = p.join('.');
    }
    return s;
  }
  function parse(str){
    var m = str.replace(/,/g,'').match(/^(\d+(?:\.\d+)?)(.*)$/);
    if(!m) return null;
    var num = m[1];
    return {
      target: parseFloat(num),
      dec: (num.split('.')[1] || '').length,
      comma: /,/.test(str) || parseFloat(num) >= 1000,
      suffix: m[2],
      orig: str
    };
  }
  function run(el){
    /* only the first text node holds the number; any trailing <span class="star">
       must be left untouched (otherwise we'd double up the star). */
    var node = el.childNodes[0];
    var isText = node && node.nodeType === 3;
    var p = parse((isText ? node.nodeValue : el.textContent).trim());
    if(!p){ return; }
    function write(s){ if(isText){ node.nodeValue = s; } else { el.textContent = s; } }
    var dur = 1500, start = null;
    function step(ts){
      if(!start) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      write(fmt(p.target * eased, p.dec, p.comma) + p.suffix);
      if(t < 1) requestAnimationFrame(step);
      else { write(p.orig); }
    }
    requestAnimationFrame(step);
  }
  function init(){
    var nums = document.querySelectorAll('.jugo-revhero [data-countup]');
    if(!nums.length) return;
    if(!('IntersectionObserver' in window)){ nums.forEach(run); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          io.unobserve(e.target);
          run(e.target);
          var stat = e.target.closest('.jugo-revhero__stat');
          if(stat){ stat.classList.add('is-in'); }
        }
      });
    }, { threshold: 0.4 });
    nums.forEach(function(n){ io.observe(n); });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twmp-socialproof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-scroll]');
    if (!track) return;
    var arrowsWrap = root.querySelector('[data-arrows]');

    if (arrowsWrap) {
      arrowsWrap.querySelectorAll('[data-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
          track.scrollBy({ left: dir * 400, behavior: 'smooth' });
        });
      });
    }

    var lastScrollY = window.scrollY;
    var touchActive = false;
    var inViewport  = false;

    track.addEventListener('touchstart', function () { touchActive = true;  }, { passive: true });
    track.addEventListener('touchend',   function () { touchActive = false; }, { passive: true });
    track.addEventListener('touchcancel',function () { touchActive = false; }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inViewport = e.isIntersecting;
          if (inViewport) lastScrollY = window.scrollY;
        });
      }, { threshold: 0 }).observe(root);
    } else {
      inViewport = true;
    }

    window.addEventListener('scroll', function () {
      if (touchActive || !inViewport) {
        lastScrollY = window.scrollY;
        return;
      }
      var dy = window.scrollY - lastScrollY;
      lastScrollY = window.scrollY;
      var speed = window.innerWidth < 768 ? 0.3 : 0.8;
      var max = track.scrollWidth - track.clientWidth;
      track.scrollLeft = Math.max(0, Math.min(track.scrollLeft + dy * speed, max));
    }, { passive: true });

    root.querySelectorAll('.twmp-living-root__video').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      var btn   = wrap.querySelector('.twmp-living-root__video-play');
      if (!video || !btn) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (video.paused) {
          video.muted = false;
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
          wrap.classList.add('is-playing');
        } else {
          video.pause();
          wrap.classList.remove('is-playing');
        }
      });

      video.addEventListener('pause', function () {
        wrap.classList.remove('is-playing');
      });
      video.addEventListener('play', function () {
        if (!video.muted) wrap.classList.add('is-playing');
      });
    });
  }

  function boot() { document.querySelectorAll('.twmp-living-root').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twmp-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStoryCounters(root) {
    var els = root.querySelectorAll('.count-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        var target = parseInt(el.getAttribute('data-count'), 10) || 0;
        el.textContent = target.toLocaleString() + '+';
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-count'), 10) || 0;
        var duration = 1500;
        var start = performance.now();
        function tick(now) {
          var elapsed = now - start;
          var progress = Math.min(elapsed / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.floor(target * eased).toLocaleString() + '+';
          if (progress < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        observer.unobserve(el);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { observer.observe(el); });
  }
  document.querySelectorAll('.twmp-story-root').forEach(initStoryCounters);
})();

  } catch(e) { console.error(e); }
})();
})();
